



































































































































































































































































































import Vue from 'vue';
import { mapGetters, mapMutations } from 'vuex';
import { EventBus } from '@/event-bus';

import authService from '@/services/AuthService';
import shipmentsService from '@/services/ShipmentsService';
import domService from '@/services/DOMService';
import sessionStorageService from '@/services/SessionStorageService';
import shipmentUtils from '@/utils/ShipmentUtils';
import miscService from '@/services/MiscService';
import exportService from '@/services/ExportService';
import cookiesService from '@/services/CookiesService';

import { Portal } from './../../enums/Portal';

import { animationMixin } from '@/mixins/animation';
import { iconsMixin } from '@/mixins/icons';
import { authMixin } from '@/mixins/auth';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { myShipmentsMixin } from '@/mixins/shipments/myShipments';
import { formatMixin } from '@/mixins/format';

import { ShipmentSearch } from '@/models/shipments/search/ShipmentSearch';
import { ShipmentsSearchOptions } from '@/models/shipments/ShipmentsSearchOptions';
import { OverriddenColumn } from '@/models/misc/OverriddenColumn';

export default Vue.extend<any, any, any, any>({
  name: 'my-shipments',
  mixins: [
    iconsMixin,
    breakpointsMixin,
    authMixin,
    animationMixin,
    myShipmentsMixin,
    formatMixin,
  ],
  data() {
    return {
      totalCount: 0,
      pageSize: 20,
      shipments: [] as ShipmentSearch[],
      page: [] as ShipmentSearch[],
      loading: false as Boolean,
      loadingMsg: null,
      deleting: false as Boolean,
      cancelling: false as Boolean,
      currentPage: 1,
      currentShipmentId: null,
      shipmentCancelFailedInfo: null,
      showShipmentCancelFailedPopup: false,
      showShipmentSuccessfullyCancelledPopup: false,
      currentCancellationState: null,

      snackbar: false,
      snackbarText: '',
      snackbarError: false,
      snackbarErrorText: '',
      displayFilters: false,
      displayConfirmDelete: false,
      displayConfirmCancel: false,
      displayMakeCopy: false,
      displayNoTracking: false,
      displayDocuments: false,
      selectedShipment: null as ShipmentSearch,
      isDefaultLayout: true,

      // merge feature
      rerenderMergeWindow: 0,
      gridRenderKey: 0,
      combining: false,
    };
  },
  mounted() {
    this.savedSearch();
    this.setupLayout();
  },
  methods: {
    ...mapMutations('shipmentDetails', ['setDisplayDetails']),
    setupLayout() {
      EventBus.$on('grid-mode-changed', this.changeLayout);
      this.isDefaultLayout = cookiesService.get('gridMode') != 'true';
    },
    search(options) {
      // hack to hide autocomplete dropdowns from filters popup
      domService.bodyClick();

      this.displayFilters = false;
      this.loading = true;
      this.loadingMsg = 'Loading shipments...';
      if (options == null) {
        options = new ShipmentsSearchOptions();
      }

      // Search by Account # if Customer Portal
      const accountId = this.user.accountId;
      const portal = authService.portal();
      if (portal == Portal.Customer && accountId) {
        options.accounts = [accountId];

        // not a company admin
        if (!this.viewOthersShipQuotes) {
          options.users = [this.user.userId];
        }
      }

      // booking agent check
      if (this.bookingAgent) {
        options.users = [this.user.userId];
        options.accounts = [];
      }

      if (this.accessControlUserIds?.length) {
        options.users = [...options.users, ...this.accessControlUserIds];
      }

      // landstar check
      this.landstarCheck(options);

      shipmentsService
        .searchWithPaging(options, this.currentPage)
        .then((x: any) => {
          this.shipments = x.data;
          this.page = x.data;
          this.totalCount = x.totalCount;
          this.loading = false;

          // show snack bar
          this.showJustSavedShipmentMessage();
        });
    },
    showDetails(shipment, extraStops) {
      this.selectedShipment = shipment;
      this.selectedShipment.extraStops = extraStops;

      this.setDisplayDetails(true);
    },
    csvExportV2() {
      this.loading = true;
      let options = sessionStorageService.get('shipments-search-options');
      if (options == null) {
        options = new ShipmentsSearchOptions();
      }

      // Search by Account # if Customer Portal
      const accountId = this.user.accountId;
      const portal = authService.portal();
      if (portal == Portal.Customer && accountId) {
        options.accounts = [accountId];

        // not a company admin
        if (!this.viewOthersShipQuotes) {
          options.users = [this.user.userId];
        }
      }

      // booking agent check
      if (this.bookingAgent) {
        options.users = [this.user.userId];
        options.accounts = [];
      }

      if (this.accessControlUserIds?.length) {
        options.users = [...options.users, ...this.accessControlUserIds];
      }

      shipmentsService
        .search(options)
        .then((x) => {
          let data = x || [];

          if (data.length) {
            data.forEach((x: any) => {
              const isLate = shipmentUtils.isLate(x);
              x.performance = isLate ? 'LATE' : 'ON TIME';

              if (!x.customerReference) x.customerReference = '';
            });
          }

          const overrides = [
            new OverriddenColumn('Pickup Date', 'Act Pickup'),
            new OverriddenColumn('Delivery Date', 'Act Delivery'),
            new OverriddenColumn('Performance', 'ETA'),
          ];

          if (miscService.isWatsco(this.user?.accountId)) {
            overrides.push(
              new OverriddenColumn(
                'Customer Reference',
                'Order/Transfer/Vendor Return #'
              )
            );
          }

          exportService.csvDownload(
            data,
            'My Shipments',
            shipmentUtils.myShipmentsCsvColumnsOrder(),
            overrides
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    changeLayout() {
      this.isDefaultLayout = cookiesService.get('gridMode') != 'true';
    },
    isCardSelectable(ship) {
      // comes from system settings & only available for pending orders for now
      return this.mergeUnmergeEnabledInCustPortal && ship?.status === 'PENDING';
    },
    combine() {
      this.rerenderMergeWindow++;
      this.$store.commit('consolidation/resetState');

      if (this.selectedShipments.length === 1) {
        this.$toast.error(
          'Please select at least two pending orders to merge.'
        );
        return;
      }

      if (!this.canMergeManually) {
        this.$toast.error(
          'Please select at least two pending orders to merge.'
        );
        return;
      }

      this.combining = true;
    },
    combineOrdersClosed() {
      this.combining = false;
      this.$store.commit('consolidation/resetSelection');

      this.gridRenderKey++;
    },
    copyOrderIds(value) {
      this.$toast.show(`Order ID(s) copied to clipboard (${value})`);
      domService.copyToClipboard(value);
    },
    unmerged(ids) {
      this.$toast.show(
        `The pending orders have been unmerged and are now searchable: ${ids}`
      );

      this.savedSearch();
      this.gridRenderKey++;
    },
  },
  computed: {
    shipmentCancelFailedInfoComputed() {
      return this.shipmentCancelFailedInfo;
    },
    currentCancellationStateComputed() {
      return this.currentCancellationState;
    },
    showCards() {
      return this.isDefaultLayout;
    },
    showGrid() {
      return !this.isDefaultLayout;
    },
    ...mapGetters('shipmentDetails', ['displayDetails']),
    ...mapGetters('consolidation', [
      'selectedShipments',
      'consolidationPopupWidth',
    ]),
    showCombine() {
      return (
        this.mergeUnmergeEnabledInCustPortal &&
        this.isCustomerPortal &&
        this.selectedShipments.length > 0
      );
    },
    showMergeWindow() {
      return this.combining && this.canMergeManually;
    },
    canMergeManually() {
      return this.selectedShipments.length > 1;
    },
    hideCountLabel() {
      const width = this.$vuetify.breakpoint.width;
      return this.showCombine && width >= 1264 && width <= 1415;
    },
    myShipmentsButtonsLgSize() {
      if (this.hideCountLabel && this.showCards) return 10;
      return 9;
    },
    myShipmentsButtonsXlSize() {
      if (this.showCombine && this.showCards) return 8;

      return 7;
    },
  },
  watch: {
    combining() {
      if (this.combining && !this.selectedShipments.length) {
        this.combining = false;
      }
    },
  },
});
